import { key } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IPlanFeedbackCourseProgramSlot, IPlanFeedbackProgramSlot } from './plan_feedback_course_builder';

export class PlanFeedbackProgramSlot {
  diff: 'MET' | 'UNMET';
  id: key;
  nk: string;
  program_slot: number | null;
  program_slot_obj: IPlanFeedbackProgramSlot | IPlanFeedbackCourseProgramSlot;
  resolution: number | null;
  comment?: string | null;
  from_comment?: string | null;
  constructor(planFeedbackProgramSlot: Partial<PlanFeedbackProgramSlot>) {
    _4.merge(this, planFeedbackProgramSlot);
  }

  static build(planFeedbackProgramSlot: Partial<PlanFeedbackProgramSlot>): PlanFeedbackProgramSlot {
    return new PlanFeedbackProgramSlot(planFeedbackProgramSlot);
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/builders/plan_feedback_program_slot_builder.ts